import { EGoalType, type Goal as GoalModel } from '@feathr/blackbox';

interface IShouldRenderArgs {
  goal: GoalModel;
}

export function shouldRender({ goal }: IShouldRenderArgs): boolean {
  const goalType = goal.get('conv_type');
  const segment = goal.get('segment');

  switch (goalType) {
    // Do not render if no goal type is selected.
    case undefined:
      return false;

    /** Do not render for Conversion Pixel Trigger and Group entry goals
     * until a segment is selected. */
    case EGoalType.conversion_pixel:
      return segment !== undefined;

    case EGoalType.group_entry:
      return segment !== undefined;

    // Render unconditionally for all other goal types.
    case EGoalType.page_view:
      return true;

    case EGoalType.form_submission:
      return true;

    case EGoalType.donation_form_submission:
      return true;
  }

  return true;
}
